import { C } from "../../constants/theme";
import FadeIn from "../ui/FadeIn";
import RainbowDivider from "../ui/RainbowDivider";
import NafsTree from "../ui/NafsTree";

const DaySchedule = () => {
  return (
    <section id="a-day-here" style={{ background: C.warmGray, padding:"100px 6vw" }}>
      <div style={{ maxWidth:1100, margin:"0 auto" }}>
        <FadeIn>
          <div style={{ textAlign:"center", marginBottom:60 }}>
            <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:C.mint, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:12 }}>What Your Child Experiences</div>
            <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(26px,4vw,46px)", color:C.navy, margin:"0 0 16px" }}>Five Dimensions.<br/>One Whole Child.</h2>
            <RainbowDivider />
            <p style={{ fontFamily:"Nunito", fontSize:15, color:C.muted, maxWidth:580, margin:"0 auto", lineHeight:1.75 }}>
              Every subject is taught, but never in isolation — each one is woven into one of five dimensions of who your child is as a human being, as Allah created them.
            </p>
          </div>
        </FadeIn>
        <FadeIn delay={0.1}>
          <NafsTree />
        </FadeIn>
      </div>
    </section>
  );
};

export default DaySchedule;
